// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zVnSt","content":"styles_content__+yW+r"};